import Cookie from 'js-cookie';

var ACCESS_TOKEN_COOKIE_NAME = 'access_token';
var REFRESH_TOKEN_COOKIE_NAME = 'refresh_token';
var hostname = window.location.hostname;
var domain = hostname.indexOf('.') > 0 ? hostname.split('.').slice(-2).join('.') : hostname;
var getAccessTokens = function () { return ({
    accessToken: Cookie.get(ACCESS_TOKEN_COOKIE_NAME),
    refreshToken: Cookie.get(REFRESH_TOKEN_COOKIE_NAME),
}); };
var removeAccessTokens = function () {
    Cookie.remove(ACCESS_TOKEN_COOKIE_NAME, { domain: domain });
    Cookie.remove(REFRESH_TOKEN_COOKIE_NAME, { domain: domain });
};
var setAccessTokens = function (accessToken, refreshToken) {
    var expires = 120000;
    Cookie.set(ACCESS_TOKEN_COOKIE_NAME, accessToken, { domain: domain, expires: expires });
    Cookie.set(REFRESH_TOKEN_COOKIE_NAME, refreshToken, { domain: domain, expires: expires });
};

export { ACCESS_TOKEN_COOKIE_NAME as A, REFRESH_TOKEN_COOKIE_NAME as R, getAccessTokens as g, removeAccessTokens as r, setAccessTokens as s };
//# sourceMappingURL=accessTokens-74425a4a.js.map
